export default "__VITE_ASSET__FIKwqRq9__"